<template>
  <div>
    <Search ref="search" @on-search="onSearch" @on-reset="onReset" />

    <div class="search-box-type">
      <div class="search-type">
        <span class="search-label" style="width: 100px">功效原料：</span>
        <el-checkbox-group
          v-model="tableParam.data.rawMaterialEfficacyList"
          @change="getList"
        >
          <el-checkbox
            v-for="(item, index) in raw_material_efficacy"
            :key="index"
            :label="item.label"
            name="type"
          ></el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="search-type">
        <span class="search-label" style="width: 75px">基础原料：</span>
        <el-checkbox-group
          v-model="tableParam.data.rawMaterialFunctionList"
          @change="getList"
        >
          <el-checkbox
            v-for="(item, index) in raw_material_function"
            :key="index"
            :label="item.label"
            name="type"
          ></el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="search-type">
        <span class="search-label" style="width: 130px">生产产地：</span>
        <el-radio-group
          v-model="tableParam.data.productionCountryName"
          @change="radioChange"
        >
          <el-radio
            v-for="(item, index) in allCommonCountry"
            :key="index"
            :label="item.name"
            name="type"
          ></el-radio>
        </el-radio-group>
        <CountrySelectDialog
          ref="countrySelectDialog"
          @country-change="countryChange"
        />
        <el-button
          class="more-btn more-btn2"
          size="mini"
          type="text"
          @click="clearCountry"
          >清空</el-button
        >
      </div>
    </div>

    <div class="sample-list" v-loading="tableLoading">
      <SortFilterBtn
        ref="sortFilterBtn"
        :showBtnList="['xp']"
        @change-list="sortChangeList"
      />
      <CommonTable
        style="margin-top: 5px;"
        ref="CommonTableRef"
        :loading="tableLoading"
        :tableHead="tableHead"
        :tableData="tableData"
        :tableParam="tableParam"
        :showCheckbox="false"
        @page-size-change="pageSizeChange"
      >
        <template #nameSlot="{ row }">
          <span class="highlight-text" @click="handlerClick(row)">{{
            row.productName
          }}</span>
        </template>
        <template #allNameSlot="{ row }">
          <p>{{ row.englishInciName }}</p>
          <span>{{ row.chineseInciName }}</span>
        </template>
      </CommonTable>
    </div>
  </div>
</template>
<script>
import Search from './Search';
import SortFilterBtn from '@/components/SortFilterBtn';
import CountrySelectDialog from '@/components/CountrySelectDialog';
import CommonTable from '@/components/CommonTable';

export default {
  components: {
    Search,
    SortFilterBtn,
    CountrySelectDialog,
    CommonTable,
  },
  props: {},
  data() {
    const {
      fabric_category,
      fabric_type,
    } = this.$store.getters.allDictListData.data;
    return {
      activeName: 'first',
      searchVal: '',
      tableParam: {
        pageNo: 1,
        pageSize: 10,
        data: {
          keyWords: '',
          rawMaterialEfficacyList: [],
          rawMaterialFunctionList: [],
          productionCountryName: '',
        },
      },
      tableLoading: false,
      tableData: {},
      tableHead: [
        {
          label: '产品名称',
          prop: 'productName',
          slotColumn: true,
          slotName: 'nameSlot',
        },
        { label: '外观形态 ', prop: 'appearance' },
        {
          label: 'INCI中/英文名称',
          prop: 'name',
          slotColumn: true,
          slotName: 'allNameSlot',
        },
        { label: '建议添加量', prop: 'recommendedAddition' },
        { label: '使用说明', prop: 'instructions' },
        { label: '生产厂地', prop: 'productionCountryName' },
        { label: '生产厂家', prop: 'manufacturer' },
        { label: '供应商', prop: 'supplierName' },
      ],
      raw_material_efficacy: [],
      raw_material_function: [],
      allCommonCountry: [],
      searchTypeData: [
        {
          label: '膜布分类',
          name: 'mbflActiveName',
          list: fabric_category,
          tag: 'CheckboxGroup',
        },
        {
          label: '膜布类型',
          name: 'mblxActiveName',
          list: fabric_type,
          tag: 'CheckboxGroup',
        },
      ],
    };
  },
  watch: {
    'tableParam.data.productionCountryName'() {
      this.getList();
    },
  },
  mounted() {
    const {
      raw_material_efficacy,
      raw_material_function,
    } = this.$store.getters.allDictListData.data;
    this.raw_material_efficacy = raw_material_efficacy;
    this.raw_material_function = raw_material_function;
    this.getAllCommonCountry();
  },
  methods: {
    getAllCommonCountry() {
      this.$http.setting
        .getListAllCommonCountry()
        .then(result => {
          this.allCommonCountry = result.data;
        })
        .catch(err => {
          this.$message.error(err.msg);
        });
    },
    getList() {
      this.tableLoading = true;
      this.$http.sampleApply
        .getRawMaterialListPage(this.tableParam)
        .then(result => {
          this.tableData = {
            list: result.data.list,
            total: result.data.total,
          };
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    handlerClick(item) {
      this.$refs.CommonTableRef.$refs.vxeTable.closeTooltip();
      const pageName = item.productName;
      const pageUrl = `details-page/goods`;
      const type = 'material';
      this.$store.dispatch('tagsView/jumpAndClosePage', {
        open: {
          name: pageName,
          href: `/${pageUrl}?type=${type}&id=${item.id}&productId=${item.productId}&productName=${encodeURIComponent(item.productName)}`,
        },
      });
      this.$router.push({
        name: pageUrl,
        params: {
          name: pageName,
          id: item.id,
          productId: item.productId,
          productName: item.productName,
          type,
        },
        query: {
          id: item.id,
          productId: item.productId,
          productName: item.productName,
          type,
        },
      });
    },
    // 分页
    handlePageChange({ pageNo, pageSize }) {
      this.tableParam.pageNo = pageNo;
      this.tableParam.pageSize = pageSize;
      this.getList();
    },
    inputChange(val) {
      this.tableParam.data.keyWords = val;
    },
    onSearch(val) {
      this.tableParam.data.keyWords = val;
      this.tableParam.pageNo = 1;
      this.getList();
    },
    sortChangeList(name, val) {
      let data = this.tableParam.data;
      delete data.newSort;
      data[name] = val;
      this.getList();
    },
    onReset() {
      let data = this.tableParam.data;
      delete data.newSort;
      this.tableParam.data.productionCountryName = '';
      this.tableParam.data.rawMaterialEfficacyList = [];
      this.tableParam.data.rawMaterialFunctionList = [];
      this.$refs.countrySelectDialog.searchResult = '';
      this.$refs.sortFilterBtn.onReset();
      this.getList();
    },
    radioChange() {
      this.$refs.countrySelectDialog.searchResult = '';
    },
    countryChange(val) {
      this.tableParam.data.productionCountryName = val;
    },
    clearCountry() {
      this.tableParam.data.productionCountryName = '';
      this.$refs.countrySelectDialog.searchResult = '';
    },
    pageSizeChange(pageNo, pageSize) {
      this.tableParam.pageNo = pageNo;
      this.tableParam.pageSize = pageSize;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.search-box-type {
  border: 1px solid #ccc;
  margin-bottom: 5px;
  padding: 0 10px;
}
/deep/ .search-type {
  max-width: 1170px;
  display: flex;
  align-items: flex-start;
  font-size: 14px;
  position: relative;
  border-bottom: 1px dashed #ccc;
  &:last-child {
    border: none;
  }
  .search-label {
    line-height: 30px;
    display: inline-block;
    margin-right: 0;
  }
  .el-tabs {
    width: calc(~'100% - 150px');
  }
  .el-tabs__header {
    margin: 0 !important;
  }
  .el-tabs__active-bar,
  .el-tabs__nav-wrap::after {
    height: 0;
  }
  .el-radio {
    line-height: 20px;
    margin: 3px 20px 3px 0;
  }
  .el-checkbox {
    margin: 5px 10px;
  }
  .more-btn {
    position: absolute;
    right: 345px;
    bottom: 1px;
  }
  .more-btn2 {
    right: 300px;
  }
}
/deep/ .sample-list {
  max-width: 1170px;
  .el-tabs__item {
    height: 30px;
    line-height: 30px;
    padding: 0 10px;
  }
  .el-tabs__nav {
    height: 30px;
  }
}
.highlight-text {
  color: #AB0033;
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
}
</style>